import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { InputProfile, SelectProfile } from '../../../components/profile';

export const ShopifyIntegrationForm = ({
    props,
    createLoading,
    platform,
    project
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-4'>
        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="URL de la boutique"
                name="url"
                placeholder="Ex: https://ma-boutique.myshopify.com"
            />
        </div>

        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="Version"
                name="version"
                placeholder="Ex: 2025-01"
            />
        </div>

        <div className="w-full">
            <InputProfile
                formikProps={props}
                type="text"
                text="Token d'accès"
                name="access_token"
                placeholder="shpat_..."
            />
        </div>

        <LoadingButton
            type="submit"
            loading={createLoading || props.isSubmitting}
            variant="contained"
            sx={{
                textTransform: 'none',
                bgcolor: '#8b5cf6',
                '&:hover': {
                    bgcolor: '#7c3aed',
                },
            }}
        >
            {project ? platform?.updateBtnText :  platform?.btnText}
        </LoadingButton>
    </div>
  );
};

export const ShopifySettingsForm = ({
    props,
    onlineDatas=null,
    isExport=false
}) => {
  const { t } = useTranslation();

  const publish_states = [
    { name: "publish", label: "Publié" },
    { name: "draft", label: "Brouillon" }
  ];

  useEffect(() => {
    if (onlineDatas && !props.values["blog_url"]) {
      props.setFieldValue('blog_url', onlineDatas["blogs_urls"][props.values["blog_id"]] );
    }
  }, [onlineDatas]);

  useEffect(() => {
    if (onlineDatas) {
      props.setFieldValue('blog_url', props.values["blog_id"] === "Sélectionnez un blog" ? "" : onlineDatas["blogs_urls"][props.values["blog_id"]]);
    }
  }, [props.values["blog_id"]]);

  return (
    <div>

        <div className="flex flex-col gap-2 mb-4">
            <div className="sm:flex sm:space-x-4">
                <div className="sm:w-1/2 flex flex-col gap-4">
                    <div className="w-full">
                        <SelectProfile
                            formikProps={props}
                            options={publish_states}
                            text={t("publish-states", "État de publication")}
                            name="publish_status"
                            required={true}
                        />
                    </div>
                </div>

                <div className="sm:w-1/2 flex flex-col gap-4">
                    <div className="w-full">
                        <SelectProfile
                            formikProps={props}
                            options={onlineDatas ? [{ name: null, label: "Sélectionnez un blog" }, ...onlineDatas?.blogs_select] : [{ name: null, label: "Sélectionnez un blog" }]}
                            text="Blog"
                            name="blog_id"
                            required={true}
                        />
                    </div>
                </div>
            </div>

            {!isExport ??
                <div className="w-full">
                    <InputProfile
                        formikProps={props}
                        type="text"
                        text="Chemin d'URL du blog par défaut"
                        name="blog_url"
                        placeholder="Ex: https://botblogr.com/blog"
                    />
                </div>
            }
        </div>
    </div>
  );
};